var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewPlace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.21,
    height: 18.039,
    viewBox: "0 0 20.21 18.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14394",
    "data-name": "Group 14394",
    transform: "translate(-311.242 -437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map",
    transform: "translate(311.092 437.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3053",
    "data-name": "Path 3053",
    d: "M1,4.876v11.5L6.032,13.5l5.751,2.876L16.816,13.5V2L11.784,4.876,6.032,2Z",
    transform: "translate(0 -0.017)",
    fill: "none",
    stroke: "var(--theme-text)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_169",
    "data-name": "Line 169",
    y2: 11,
    transform: "translate(5.908 2.172)",
    fill: "none",
    stroke: "var(--theme-text)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_170",
    "data-name": "Line 170",
    y2: 11,
    transform: "translate(11.908 5.172)",
    fill: "none",
    stroke: "var(--theme-text)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14393",
    "data-name": "Group 14393",
    transform: "translate(-0.042)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4331",
    "data-name": "Rectangle 4331",
    width: 8.042,
    height: 10,
    transform: "translate(322 437)",
    fill: "var(--theme-sec-bg)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(325.339 439.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M62.154,73.812h-5.4",
    transform: "translate(-56.75 -71.106)",
    fill: "none",
    stroke: "var(--theme-text)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727-2",
    "data-name": "Path 727",
    d: "M5.4,0H0",
    transform: "translate(2.702) rotate(90)",
    fill: "none",
    stroke: "var(--theme-text)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPlace);
export default __webpack_public_path__ + "static/media/newPlace.da769cb0522c761ce59e23e8f85980db.svg";
export { ForwardRef as ReactComponent };